export default "__VITE_ASSET__CZWQN$OK__"